export default "__VITE_ASSET__BOdaf1vp__"